import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

export default ({ color = defaultIconColor, ...props }: Omit<SVGComponentPropsType, 'size'>) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="41" height="22" {...props}>
    <defs>
      <filter id="a">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 0.615686 0 0 0 0 0.631373 0 0 0 0 0.666667 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g transform="translate(-417 -102)" fill="none" fillRule="evenodd">
      <g stroke={color} strokeWidth="2">
        <circle cx="3.81" cy="3.81" r="3.81" transform="matrix(-1 0 0 1 451.265 114.492)" />
        <circle cx="3.81" cy="3.81" r="3.81" transform="matrix(-1 0 0 1 431.286 114.492)" />
        <path d="M454.354 118.238a2.919 2.919 0 0 0 1.652-3.728l-2.71-7.277h0a2.016 2.016 0 0 0-1.307-3.439l-10.689-.63a24.31 24.31 0 0 0-5.56.312 8.203 8.203 0 0 0-4.654 2.543l-.53.579a13.201 13.201 0 0 1-5.853 3.7l-3.652 1.124a4 4 0 0 0-2.823 3.823v1.686a2.37 2.37 0 0 0 1.904 2.323h3.344M443.646 118.683l-8.285.266" />
      </g>
    </g>
  </svg>
);
